export default "__VITE_ASSET__l13u5BpK__"